import {
	useGoalsRightOptional,
	usePortfolioRightOptional,
} from "web_myplann/Api/Rights/RightsProvider";

export const useFlatRowRedesign = (): boolean => {
	const hasGoalsRight = useGoalsRightOptional();
	const { hasRight: hasPortfolioRight } = usePortfolioRightOptional();

	return hasGoalsRight || hasPortfolioRight;
};
